import { render, staticRenderFns } from "./RootTariffeView.vue?vue&type=template&id=16b89d0a&"
import script from "./RootTariffeView.vue?vue&type=script&lang=ts&"
export * from "./RootTariffeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports